import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MnmFormState } from './mnm-form.state';

export function linkDateRange(
    formState: MnmFormState,
    fromFieldName: string,
    toFieldName: string,
    unsubscribeAll: Observable<unknown>
): void {
    const fromControl = formState.group.controls[fromFieldName];
    const toControl = formState.group.controls[toFieldName];
    const toField = formState.get(toFieldName);

    const applyConstraint = (fromValue: unknown): void => {
        toField.minDate = fromValue ? new Date(fromValue as string) : undefined;

        const toValue = toControl.value;
        if (
            fromValue &&
            toValue &&
            new Date(toValue) < new Date(fromValue as string)
        ) {
            toControl.setValue(null);
        }
    };

    // Apply immediately so edit dialogs pre-populated before this call
    // are constrained from the start, not only after the user changes from.
    applyConstraint(fromControl.value);

    fromControl.valueChanges
        .pipe(takeUntil(unsubscribeAll))
        .subscribe(applyConstraint);
}
